import React from "react";
import {
  Box,
  Grid,
  Tab,
  Tabs,

} from "@mui/material";
import useTabs from "../../../shared/hooks/useTabs";
import { capitalCase } from "change-case";
import Page from "../../../shared/components/Page";
import ShopProfile from "../components/ShopProfile";
import Notifications from "../components/Notifications";
import Signatory from "../components/Signatory";
import Title from "src/shared/Text/Title";
import ConfigurationsTable from "../components/ConfigurationsTable";


export default function Shop() {
  const { currentTab, onChangeTab } = useTabs('Shop Profile');


  const TABS = [
    {
      value: 'Shop Profile',
      component: <ShopProfile />,
    },
    {
        value: 'Set Notification Number',
        component: <Notifications />,
      },
    {
      value: 'Split Settings Table',
      component: <ConfigurationsTable />,
    },
    
    {
        value: 'Signatory  Settings',
        component: <Signatory />,
      },
    
    
  ];


  return (
    <Page title="My Shop Settings">
      <Box sx={{ m: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: "space-between", mb: 2 }} >
          <Title text="My Shop Settings" sx={{ color: 'black' }} />
        </Box>
      </Box>
      <Grid item xs={12} md={12}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Tabs
            
            allowScrollButtonsMobile
            variant="scrollable"
            scrollButtons="auto"
            value={currentTab}
            onChange={onChangeTab}
          >
            {TABS.map((tab) => (
              <Tab disableRipple key={tab.value} label={capitalCase(tab.value)} icon={tab.icon} value={tab.value} />
            ))}
          </Tabs>
        </div>
        <Box sx={{ mb: 5 }} />
        {TABS.map((tab) => {
          const isMatched = tab.value === currentTab;
          return isMatched && <Box key={tab.value}>{tab.component}</Box>;
        })}
      </Grid>


    </Page>
  );
}
